var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContainer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15L5 13.25L1.125 14.75C0.847222 14.8611 0.590278 14.8299 0.354167 14.6562C0.118056 14.4826 0 14.25 0 13.9583V2.29167C0 2.11111 0.0520833 1.95139 0.15625 1.8125C0.260417 1.67361 0.402778 1.56944 0.583333 1.5L5 0L10 1.75L13.875 0.25C14.1528 0.138889 14.4097 0.170139 14.6458 0.34375C14.8819 0.517361 15 0.75 15 1.04167V12.7083C15 12.8889 14.9479 13.0486 14.8438 13.1875C14.7396 13.3264 14.5972 13.4306 14.4167 13.5L10 15ZM9.16667 12.9583V3.20833L5.83333 2.04167V11.7917L9.16667 12.9583Z",
    fill: "#2E7D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer2);
export default __webpack_public_path__ + "static/media/Container (2).c4cd1fea8c7b644570945f31ba2f04ea.svg";
export { ForwardRef as ReactComponent };